import { createApp } from 'vue';

import App from './App.vue';
import router from './router';
import { vueErrorHandler } from './utils/errorHandler';

const app = createApp(App);

app.config.errorHandler = vueErrorHandler;

app.use(router).mount('#app');
